import React, { useMemo } from 'react'
import BodyTextBlock from 'components/Luxkit/TextBlocks/BodyTextBlock'
import TextLink from 'components/Luxkit/TextLink'
import Group from 'components/utils/Group'
import { getInclusionIcon } from 'lib/offer/getInclusionIcon'
import { sum, take } from 'lib/array/arrayUtils'
import styled from 'styled-components'
import { rem } from 'polished'
import config from 'constants/config'

const AmenitiesGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-row-gap: ${rem(8)};
  grid-column-gap: ${rem(24)};
  overflow: hidden;

`

function BedbankFacilities({ popularFacilities, facilities, offerUrl }: { popularFacilities: Array<string>, facilities?: App.BedbankOffer['facilityGroups'], offerUrl: string }) {
  const totalFacilities = useMemo(() => facilities ? sum(facilities, facilityGroup => facilityGroup.values.length) : 0, [facilities])
  return (<>
    {popularFacilities.length > 0 && <Group direction="vertical" gap={8}>
      <AmenitiesGrid>
        {take(popularFacilities, 6).map((facility) => {
          const icon = facility.toLowerCase().split(' ').join('_')
          const FacilityIcon = getInclusionIcon(icon)
          return <BodyTextBlock
              key={facility}
              variant="medium"
              format="titlecase"
              startIcon={<FacilityIcon data-testid={icon} size="S" />}
            >
            {facility}
          </BodyTextBlock>
        })}
      </AmenitiesGrid>
      {!!totalFacilities &&
        <TextLink weight="bold" target={ config.OPEN_NEW_TAB_OFFER_CLICK ? '_blank' : undefined } underline size="medium" to={offerUrl + '#facilities-all'} >
          View all {totalFacilities} amenities
        </TextLink>
        }
    </Group>
  }
  </>)
}

export default BedbankFacilities
